import React, { useMemo } from 'react';

const Snowfall = ({ theme, intensity = 1 }) => {
  const snowflakes = useMemo(() => {
    const count = Math.floor(60 * intensity);
    return Array.from({ length: count }, (_, i) => {
      const size = Math.random() * 6 + 3;
      const x = Math.random() * 100;
      const duration = Math.random() * 10 + 10;
      const delay = Math.random() * 5;
      const sway = (Math.random() * 80 - 40);
      const opacity = Math.random() * 0.6 + 0.3;
      return { id: i, size, x, duration, delay, sway, opacity };
    });
  }, [intensity]);

  const bgColor = theme === 'dark' ? 'rgba(255,255,255,0.8)' : 'rgba(255,255,255,0.9)';

  return (
    <div className="snowfall">
      {snowflakes.map(f => (
        <div
          key={f.id}
          className="snowflake"
          style={{
            width: f.size,
            height: f.size,
            left: `${f.x}%`,
            backgroundColor: bgColor,
            opacity: f.opacity,
            animationDuration: `${f.duration}s`,
            animationDelay: `${f.delay}s`,
            '--sway': `${f.sway}px`,
          }}
        />
      ))}
    </div>
  );
};

export default Snowfall;
